import { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from "react"

export type BrowserContextType = {
  isSafari: boolean
}

export const BrowserContext = createContext<BrowserContextType>({
  isSafari: false,
})

export const BrowserContextProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [isSafari, setIsSafari] = useState(false)

  useEffect(() => {
    if (typeof window != undefined) {
      var ua = navigator.userAgent.toLowerCase()
      if (ua.indexOf("safari") != -1 && ua.indexOf("chrome") == -1) {
        console.log(`is safari!!`, navigator.userAgent)
        setIsSafari(true)
      }
    }
  }, [])

  return (
    <BrowserContext.Provider
      value={{
        isSafari,
      }}
    >
      {children}
    </BrowserContext.Provider>
  )
}

export const useBrowserContext = () => useContext(BrowserContext)
